import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabaseAgency } from "@/lib/supabase";

export interface QueueActionInput {
  itemId: string;
  actionType: "archive_email" | "mark_handled" | "snooze_item" | "acknowledge_alert";
  payload?: Record<string, unknown>;
}

export function useQueueAction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ itemId, actionType, payload = {} }: QueueActionInput) => {
      const { error } = await supabaseAgency
        .from("os_action_queue")
        .insert({
          item_id: itemId,
          action_type: actionType,
          payload,
        });
      if (error) throw error;
      return { itemId, actionType, payload };
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["action_items"] });
      qc.invalidateQueries({ queryKey: ["action_events"] });
    },
  });
}
